module.exports = __webpack_public_path__ + "static/media/keyboard-right-arrow-button-white.5f23080f.svg";